import request from '@/utils/request'

export function getWaitingPayList(schoolCode, idserial) {
  return request({
    url: 'pay/pay/waitingPay/getWaitingPayList/' + schoolCode + '/' + idserial,
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export function submitNextStep(data) {
  return request({
    url: 'pay/web/waitingPay/submitNextStep',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
export function getPayCodeListByProId(projectid) {
  return request({
    url: 'pay/web/waitingPay/getPayCodeListByProId/' + projectid,
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export function toPayOrderTrade(data) {
  return request({
    url: 'pay/web/waitingPay/toPayOrderTrade',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

